/**
 * sanitizeErrorForLog — extrae solo metadatos seguros de un error
 * para console.error, evitando leak de PII (snapshots, datos de cliente)
 * que Postgres/Supabase pueden incluir en error.details.
 *
 * Uso:
 *   console.error('[xxx]', sanitizeErrorForLog(e));
 *
 * NUNCA `console.error('[xxx]', e)` directo — el objeto completo puede
 * contener message + details + hint con PII embebida.
 */
export function sanitizeErrorForLog(e: unknown): Record<string, unknown> {
  if (e == null) return { kind: 'null' };

  if (typeof e !== 'object') {
    return { kind: typeof e, value: String(e).slice(0, 200) };
  }

  const err = e as Record<string, unknown>;
  const out: Record<string, unknown> = {};

  if (typeof err.code === 'string') out.code = err.code;
  if (typeof err.name === 'string') out.name = err.name;

  // Mensaje: truncado a 200 chars para evitar volcar query bodies enteros.
  if (typeof err.message === 'string') {
    out.message = err.message.slice(0, 200);
  }

  // hint de PostgREST suele ser breve y no-PII; lo preservamos truncado.
  if (typeof err.hint === 'string') {
    out.hint = err.hint.slice(0, 200);
  }

  // Stack solo en dev. En prod oculta para no leak paths internos.
  if (process.env.NODE_ENV !== 'production' && typeof err.stack === 'string') {
    out.stack = err.stack.split('\n').slice(0, 5).join('\n');
  }

  // NO incluir: details (puede contener row content), constraint names verbatim,
  // query body, parameters, file/line del DB.

  return out;
}
